module.exports = __webpack_public_path__ + "img/boy.d47a3a04.png";